import React, { PureComponent } from 'react';

import { Repository } from 'src/components/types';
import { BranchingModelState } from 'src/redux/branches/reducers/branch-list-reducer';
import { BranchingModelBranch } from 'src/sections/repository/sections/branches/types';
import { Ref, RefType } from 'src/sections/repository/types';

import RefList from './ref-list';
import { generateRefUrl, fetchRefOptions } from './utils';

type FilteredRefListProps = {
  filter: string;
  onRefSelected?: (ref: Ref) => void;
  renderRef?: (ref: Ref) => any;
  repository: Repository;
  mainRef?: Ref;
  branchingModel?: BranchingModelState;
  type: RefType;
};

type FilteredRefListState = {
  isLoading: boolean;
  nextPageUrl: string | null | undefined;
  refs: Ref[];
};

// TODO: Replace usage of unsafe lifecycle methods
// eslint-disable-next-line react/no-unsafe
export default class FilteredRefList extends PureComponent<
  FilteredRefListProps,
  FilteredRefListState
> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    filter: '',
  };

  state: FilteredRefListState = {
    isLoading: false,
    refs: [],
    nextPageUrl: null,
  };

  componentDidMount() {
    const { filter, repository, type, mainRef, branchingModel } = this.props;
    this.fetchRefs(repository, filter, type, mainRef, branchingModel);
  }

  /* eslint react/no-unsafe: "warn" */
  UNSAFE_componentWillReceiveProps(nextProps: FilteredRefListProps) {
    const { filter, repository, type, mainRef, branchingModel } = nextProps;
    if (
      filter !== this.props.filter ||
      type !== this.props.type ||
      (repository &&
        (!this.props.repository ||
          this.props.repository.uuid !== repository.uuid))
    ) {
      this.fetchRefs(repository, filter, type, mainRef, branchingModel);
    }
    if (this.props.type !== type) {
      this.setState({ refs: [] });
    }
  }

  fetchRefs = (
    repository: Repository,
    filter: string,
    type: RefType,
    mainRef?: Ref,
    branchingModel?: BranchingModelState
  ): void => {
    const { full_name } = repository;
    const url = generateRefUrl(
      full_name,
      filter,
      type,
      mainRef,
      branchingModel
    );
    this.fetchRefsFromUrl(url, true);
  };

  onLoadMorePages = (nextPageUrl: string): void => {
    this.fetchRefsFromUrl(nextPageUrl, false);
  };

  fetchRefsFromUrl = async (url: string, reset: boolean): Promise<void> => {
    this.setState({ isLoading: true });

    const { refs } = this.state;
    const { type, mainRef, branchingModel, filter } = this.props;

    try {
      const { next, preparedRefs } = await fetchRefOptions(
        url,
        reset,
        filter,
        type,
        mainRef,
        branchingModel
      );

      this.setState({
        isLoading: false,
        nextPageUrl: next,
        refs: reset ? preparedRefs : refs.concat(preparedRefs),
      });
    } catch (e) {
      // XXXTODO: Render some sort of error view
      // https://softwareteams.atlassian.net/browse/BBCDEV-10781
    }
  };

  shouldShowRef = (
    ref: BranchingModelBranch | Ref | null | undefined
  ): boolean => {
    const { filter } = this.props;

    if (!ref || !ref.name) {
      return false;
    }

    return ref.name.includes(filter);
  };

  render(): JSX.Element {
    const { onRefSelected, renderRef, type, filter } = this.props;
    const { isLoading, refs, nextPageUrl } = this.state;
    const isFiltered = type === 'tag' && filter !== '';

    return (
      <RefList
        nextPageUrl={nextPageUrl}
        isLoading={isLoading}
        isFiltered={isFiltered}
        onLoadMorePages={this.onLoadMorePages}
        onRefSelected={onRefSelected}
        refs={refs}
        renderRef={renderRef}
        type={type}
      />
    );
  }
}
